module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/2lKSyk/images/cover.jpg?1703000774256",
      "alt": "This image is the cover for the book Culver City Chronicles, American Chronicles"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Culver City Chronicles, American Chronicles\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Culver City has rivaled Hollywood for nearly a century as the \"Heart of Screenland\"--a center of the movie and television trades. Here, the giant Metro-Goldwyn-Mayer evolved into Sony Pictures, and the Ince and Selznick movie empires became today's Culver Studios. But the same lands along Ballona Creek had been a wilderness traversed by Native Americans and settled by hardy Spanish pioneers named Machado, Talamantes and Higuera. Union soldiers occupied the area's Civil War-era Camp Latham. By 1910, visionary Harry H. Culver saw possibilities for these ranchlands and led Culver City to incorporate in 1917. Join official city historian Julie Lugo Cerra, a descendant of early settlers, as she relates the fascinating stories of how and why Culver City grew and prospered.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Julie Lugo Cerra\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Julie Lugo Cerra is a sixth-generation Californian, and a Culver City native who enjoys being called \"the accidental historian.\"?  She was appointed official City historian by the Culver City Council in 1996. Julie, a past president of the Culver City Historical Society, wrote hundreds of articles about her hometown's past in the Culver City News.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    The History Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0